import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreateSupplierDto } from './create-supplier.dto';

/**
 * Update supplier DTO
 */
export class UpdateSupplierDto extends CreateSupplierDto {
	@TransformInt()
	id!: number;
}
